import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";

const DashboardLayoput = () => {
  const navList = useNav();
  let { DashbaoardBottomHeader, DashbaoardTopHeader } = navList;
  return (
    <div className="webBody">
      <Header
        bottomTabs={DashbaoardBottomHeader}
        topTabs={DashbaoardTopHeader}
      />
      <Outlet />
    </div>
  );
};

export default DashboardLayoput;
